import { Injectable, Injector } from '@angular/core';
import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest, HttpEvent, HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ErrorObservable } from 'rxjs/Observable/ErrorObservable';
import { EmptyObservable } from 'rxjs/Observable/EmptyObservable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { catchError, filter, take, switchMap, finalize } from "rxjs/operators";
import { Router,  RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { environment } from 'environments/environment';
import { User} from '../models/data.types';


@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  
  isRefreshingToken: boolean = false;
  auth : AuthenticationService;
  tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  tokenHeaders: HttpHeaders;
  tokenUrl: string;
  adTokenUrl: string;
  state : RouterStateSnapshot;

  constructor(private injector : Injector,private router: Router) {
    this.tokenHeaders = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    this.tokenUrl = environment.apiUrl+ `service/token`;
    this.adTokenUrl = environment.apiUrl+ `service/api/Account/AdLogin`;
    this.state = router.routerState.snapshot;
  }


  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
       
    this.auth = this.injector.get(AuthenticationService);    
    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${this.auth.getToken()}`
      }
    });

    return next.handle(request)
     
      catchError((error, ca) => {
        if (error instanceof HttpErrorResponse) {
          switch ((<HttpErrorResponse>error).status) {
            case 401:
            if(this.auth.getUser() != null){
              return this.handle401Error(request, next);
            }  
            else
            {
              this.router.navigate(['/login'], { queryParams: { returnUrl: this.state.url }});
            }
            default:
              return Observable.throw(error);
          }
        } else {
          return Observable.throw(error);
        }
      })
  }
  handle401Error(req: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshingToken) {
      this.isRefreshingToken = true;

      this.tokenSubject.next(null);

      const http = this.injector.get(HttpClient);

      let u : User = this.auth.getUser()

      if (u.LoginType == "AD")
      {
        let tokenRequest = 'username=' + u.username + '&password=' + u.password;

        return http.post(this.adTokenUrl,tokenRequest, {headers: this.tokenHeaders}).pipe(
          switchMap((newToken: any) => {
            if (newToken) {
              this.auth.setToken(newToken.access_token)
              this.tokenSubject.next(newToken.access_token)
              return next.handle(req);
            }
            this.auth.logout()
            console.log('Could not refresh token 1')
            return Observable.create();
          }),
          catchError(error => {
            if(error.status == 401)
            {
              return Observable.throw(error);
            }
            else
            {
              this.auth.logout()
              console.log('Could not refresh token 2')
              return Observable.create();
            }
          }),
          finalize(() => {
            this.isRefreshingToken = false;
          })
          )
      }
      else
      {
        let tokenRequest = 'grant_type=password&username=' + u.username + '&password=' + u.password;

        return http.post(this.tokenUrl,tokenRequest, {headers: this.tokenHeaders}).pipe(
          switchMap((newToken: any) => {
            if (newToken) {
              this.auth.setToken(newToken.access_token)
              this.tokenSubject.next(newToken.access_token)
              return next.handle(req);
            }
            this.auth.logout()
            console.log('Could not refresh token 1')
            return Observable.create();
          }),
          catchError(error => {
            if(error.status == 401)
            {
              return Observable.throw(error);
            }
            else
            {
              this.auth.logout()
              console.log('Could not refresh token 2')
              return Observable.create();
            }
          }),
          finalize(() => {
            this.isRefreshingToken = false;
          })
          )
      }
     
    } else {
      return this.tokenSubject
        .pipe(
        filter(token => token != null),
        take(1),
        switchMap(token => {
          return next.handle(req);
        })
        )
    }
  }
  
}


// WEBPACK FOOTER //
// ./src/app/helpers/token.interceptor.ts